/* Opent en sluit de vensters op de pagina Tarieven (1-10-2026). Een element met data-km-venster-open="id" opent het venster met dat id;
   een klik buiten het venster, op de sluitknop of de Escape-toets sluit het. Werkt zonder dit script ook als link (de kaarten zijn gewone
   links naar de webshop of een knop). */
(function () {
  if (window.kmVenster) return;
  var open = null, terug = null;
  function toon(id, bron) {
    var v = document.getElementById(id);
    if (!v) return;
    // Een venster dat vanuit een ander venster opent (Vraag je datum aan in Alle info) komt in de plaats van dat venster (5-10-2026).
    if (open && open !== v) { open.hidden = true; bron = null; }
    terug = bron || null;
    v.hidden = false;
    open = v;
    document.documentElement.style.overflow = 'hidden';
    var s = v.querySelector('[data-km-venster-sluit]');
    if (s) s.focus();
  }
  function sluit() {
    if (!open) return;
    open.hidden = true;
    open = null;
    document.documentElement.style.overflow = '';
    if (terug && terug.focus) terug.focus();
  }
  window.kmVenster = { toon: toon, sluit: sluit };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-km-venster-open]');
    if (o) { e.preventDefault(); toon(o.getAttribute('data-km-venster-open'), o); return; }
    if (open && (e.target === open || e.target.closest('[data-km-venster-sluit]'))) sluit();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sluit(); });
})();
